// eslint-disable-next-line import/no-internal-modules
import { WidgetContainerConfig } from '@insided/deprecated-preact-components/widget-container'
import { Component } from 'preact'
import { getCssVarLabel } from '../../ThemeConfigurator'
import Field from './FieldContainer'
import { AbstractFieldProps } from './types'

type TitleColorDisplayValue = WidgetContainerConfig['titleColorDisplay']

export interface TitleColorDisplayFieldProps extends AbstractFieldProps<TitleColorDisplayValue> {}

interface FieldState {
  value: TitleColorDisplayValue
}

interface Option {
  value: TitleColorDisplayValue
  label: string
}

export const TITLE_DISPLAY_OPTIONS: Option[] = [
  {
    value: 'config-header-color',
    label: getCssVarLabel('config-header-color')
  },
  {
    value: 'config--main-color-night',
    label: getCssVarLabel('config--main-color-night')
  },
  {
    value: 'solid_color',
    label: 'Custom solid color'
  }
]

const INPUT_ID = 'widget-title-color'

export class TitleColorDisplayField extends Component<TitleColorDisplayFieldProps, FieldState> {
  state = {
    value: this.props.value ?? TITLE_DISPLAY_OPTIONS[0].value
  }

  render() {
    return (
      <Field inputId={INPUT_ID} title='Title color'>
        <select
          id={INPUT_ID}
          name={INPUT_ID}
          onChange={(event) => {
            const value = (event.target as HTMLSelectElement).value as TitleColorDisplayValue
            this.setState({ value }, () => this.props.onValueChange(value))
          }}
        >
          {TITLE_DISPLAY_OPTIONS.map(({ value, label }) => (
            <option key={value} value={value} selected={this.state.value === value}>
              {label}
            </option>
          ))}
        </select>
      </Field>
    )
  }
}

export default TitleColorDisplayField
